// Module
var code = "<div ng-switch=\"vm.status\"> <i class=\"fa fa-fw fa-check success\" ng-switch-when=\"0\" title=\"{{vm.displayMessage}}\"></i> <i class=\"fa fa-fw fa-warning warning\" ng-switch-when=\"1\" title=\"{{vm.displayMessage}}\"></i> <i class=\"fa fa-fw fa-remove error\" ng-switch-when=\"2\" title=\"{{vm.displayMessage}}\"></i> </div>";
// Exports
module.exports = code;